<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_PORTL')" />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="portalSelect"
              v-model="queryData.portalId"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
              :option-list="portalList"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="homeCardSelect"
              v-model="queryData.homeCardTypeCode"
              :pagedId="this.$options.name"
              codeId="COD_HCARD_TYPE"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
              :pageId="contextPageId"
              :selectedMd="queryData.moduleCode"
              :selectedSmd="queryData.subModuleCode"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="comboSearchCond"
              v-model="queryData.searchCond"
              :pagedId="contextPageId"
              codeId="COD_HCARD_SEARCH_COND"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="searchText"
              v-model="queryData.searchText"
              placeholder=""
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="mainGrid"
        :columns="gridColumns0"
        :dataset="'dsHomeCardList'"
        :hideHeader="false"
        :autoheight="false"
        :multiselect="false"
        :pageable="false"
        :showDisplayCountControl="false"
        @rowselect="onRowSelect"
      />
      <div class="mrB30" />
      <sui-page-tab-box-type
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          ref="tabPage"
          :pageId="contextPageId"
          :selectedGridRowData="selectedGridRowData"
          @onClearSelectionMainGrid="onClearSelectionMainGrid"
          @onSearchClick="onSearchClick"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMP_00008_T01';

export default {
  name: 'PGE_CMP_00008', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
  },
  extends: BasePage,
  data() {
    return {
      codes: CommonConstants.selectOptions(),
      selectedGridRowData: {},
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_HCARD_DTL_INFO'),
          tabComponent: tab01,
        },
      ],
      queryData: {
        portalId: '',
        homeCardTypeCode: '',
        moduleCode: {
          label: '',
          key: '',
        },
        subModuleCode: {
          label: '',
          key: '',
        },
        searchCond: '',
        searchText: '',
      },
    };
  },
  datasets: [{
    id: 'dsHomeCardList',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'portalId', type: 'string', map: 'portalId' },
      { name: 'portalName', type: 'string', map: 'portalName' },
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'subModuleCode', type: 'string', map: 'subModuleCode' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'homeCardTypeCode', type: 'string', map: 'homeCardTypeCode' },
      { name: 'homeCardTypeName', type: 'string', map: 'homeCardTypeName' },
      { name: 'homeCardId', type: 'string', map: 'homeCardId' },
      { name: 'homeCardName', type: 'string', map: 'homeCardName' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'homeCardTitleUseYn', type: 'string', map: 'homeCardTitleUseYn' },
      { name: 'homeCardUseYn', type: 'string', map: 'homeCardUseYn' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { type: 'string', name: 'r_loginId', map: 'r_loginId' },
      { type: 'string', name: 'm_loginId', map: 'm_loginId' },
    ],
  }],
  computed: {},
  watch: {},
  created() {
    this.portalList = [];
    this.localdata0 = [];
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_PORTL'),
        datafield: 'portalName',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'homeCardTypeName',
      },
      {
        text: this.$t('MSG_TXT_HCARD_ID'),
        datafield: 'homeCardId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_HCARD_NM'),
        datafield: 'homeCardName',
      },
      {
        text: this.$t('MSG_TXT_PAGE_ID'),
        datafield: 'pageId',
        width: 150,
      },
      {
        text: this.$t('MSG_TXT_TTL_USE_YN'),
        datafield: 'homeCardTitleUseYn',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'homeCardUseYn',
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: 150,
      },
    ];
  },
  mounted() {
    this.loadPortalList();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadPortalList() {
      http.request(this.contextPageId, 'DTS_CMP_00004', {
      }).then(res => {
        this.portalList = [];
        if (res.data.length > 0) {
          utils.forEach(res.data, obj => {
            const portalInfo = {
              key: obj.portalId,
              label: obj.portalName,
            };
            this.portalList.push(portalInfo);
          });
          this.queryData.portalId = ''; 
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onSearchClick() {
      const queryParams = {
        portalId: this.queryData.portalId,
        homeCardTypeCode: this.queryData.homeCardTypeCode || '',
        moduleCode: this.queryData.moduleCode.key || '',
        subModuleCode: this.queryData.subModuleCode.key || '',
        searchCond: this.queryData.searchCond || '',
        searchText: utils.trim(this.queryData.searchText),
      };
      http.request(this.contextPageId, 'DTS_CMP_00028', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, 'finalModificationDTM');
        this.localdata0 = res.data;
        this.dsHomeCardList.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onClickReset() {
      this.$refs.portalSelect.reset();
      this.$refs.homeCardSelect.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.comboSearchCond.reset();
      this.queryData.searchText = '';
    },
    onClearSelectionMainGrid() {
      this.dsHomeCardList.clearSelection();
    },
    onRowSelect(target) {
      const selectIdx = target.args.rowindex;
      if (selectIdx > -1) {
        this.selectedGridRowData = this.localdata0[selectIdx];
      }
    },

  },
};
</script>
<style scoped>
</style>
